import { Switch as BaseSwitch } from "@base-ui/react/switch";
import { cx } from "../../lib/cx";

/**
 * An on/off setting, on Base UI's Switch. Replaces A2's `.p-switch`.
 *
 * The knob is `knob`, not `surface`: in dark the surface is a dark brown and
 * the knob would vanish into an off track. A2's contract ("pick a token by
 * what the thing IS") is why dark mode kept working there, and it is kept.
 *
 * The track is 48×28 as in A2; a transparent `before:` box stretches the hit
 * area to 48 px tall, so the thumb target meets the floor without the switch
 * looking any bigger.
 *
 * Controlled only (plan D09): `checked` and `onCheckedChange`.
 */

export interface SwitchProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  id?: string;
  /** The accessible name, when no visible `<label>` wraps the switch. */
  label?: string;
  onCheckedChange: (checked: boolean) => void;
}

export function Switch({
  checked,
  onCheckedChange,
  label,
  disabled,
  id,
  className,
}: SwitchProps) {
  return (
    <BaseSwitch.Root
      aria-label={label}
      checked={checked}
      className={cx(
        "relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full bg-line-strong p-0.5 transition-colors duration-150 before:absolute before:inset-x-0 before:-inset-y-2.5 data-disabled:cursor-not-allowed data-checked:bg-accent data-disabled:opacity-40",
        className
      )}
      disabled={disabled}
      id={id}
      onCheckedChange={onCheckedChange}
    >
      <BaseSwitch.Thumb className="size-6 rounded-full bg-knob shadow transition-transform duration-200 ease-out data-checked:translate-x-5" />
    </BaseSwitch.Root>
  );
}
